import { render } from "./ObjectNameComponent.vue?vue&type=template&id=610893d3&scoped=true"
import script from "./ObjectNameComponent.vue?vue&type=script&lang=js"
export * from "./ObjectNameComponent.vue?vue&type=script&lang=js"

import "./ObjectNameComponent.vue?vue&type=style&index=0&id=610893d3&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610893d3"]])

export default __exports__